document.addEventListener("DOMContentLoaded", function () {
  const toggles = document.querySelectorAll(".belt-size-guide-toggle");
  const modal = document.querySelector(".cstm-belt-size-chart__modal");

  if (!modal || !toggles.length) return;

  toggles.forEach(toggle => {
    toggle.addEventListener("click", function () {
      modal.classList.toggle("show");
    });
  });
}); 